import { render } from "./DocumentBrowserTree.vue?vue&type=template&id=d5268a08&scoped=true&ts=true"
import script from "./DocumentBrowserTree.vue?vue&type=script&lang=ts"
export * from "./DocumentBrowserTree.vue?vue&type=script&lang=ts"

import "./DocumentBrowserTree.vue?vue&type=style&index=0&id=d5268a08&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5268a08"]])

export default __exports__